import errorHandler from "../../handlers/errorHandler";
// import successHandler from "../../handlers/successHandler";
import { walletTransactionService } from "../../services/walletTransaction.service";
import walletTransactionType from "./walletTransactionTypes";


/**
 * Edit invite
 * @param {object} payLoad {company_id :"7b3e58e0-b68c-498d-b8d5-82198ef6d481"}
 * @returns {void}
 * */
export const filterWalletTransactions = (payLoad) => async (dispatch) => {
  dispatch({
      type: walletTransactionType["LOADING_WALLET_TRANSACTION"],
      payLoad: true,
    });
  try {
    const response = await walletTransactionService.filterWalletTransactions({
      ...payLoad,
    });
    dispatch({
      type: walletTransactionType["LOADING_WALLET_TRANSACTION"],
      payLoad: false,
    });
    dispatch({
      type: walletTransactionType["FILTER_WALLET_TRANSACTION"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: walletTransactionType["LOADING_WALLET_TRANSACTION"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};

